<template>
  <header
    :class="[
      'header',
      {
        'header--fixed': fixed,
      },
    ]"
  >
    <b
      :class="[
        `header__bg`,
        {
          'header__bg--fixed': fixed,
        },
      ]"
    />
    <div class="group">
      <a v-if="!isAuthenticated" :href="wpUrl" class="header__logo">
        <module-logo/>
      </a>
      <router-link v-else :class="`header__logo`" :to="{ name: `dashboard` }">
        <module-logo/>
      </router-link>
      <ui-navigation/>
    </div>
    <transition name="fade" v-if="!isAuthenticated">
      <div class="mobile-menu">
        <span class="header__links">
          <module-link
            v-for="headerLink in headerLinks"
            :key="headerLink.name"
            class="header__link ttu tdn fw-extrabold link"
            color="secondary"
            :link="headerLink.name"
            :label="headerLink.label"
            :external="false"
          />
        </span>
      </div>
    </transition>
  </header>
</template>

<script>
import config from 'config';

// Vue/Vuex
import { mapGetters } from 'vuex';

// Services
import { createScroll, destroyScroll } from 'services/scroll';

// Modules
import ModuleLogo from 'modules/Logo';
import ModuleLink from 'modules/Link';

// Ui
import UiNavigation from 'ui/Navigation';

// Export
export default {
  name: `ui-header`,

  // Components
  components: {
    ModuleLogo,
    UiNavigation,
    ModuleLink,
  },

  // Data
  data() {
    return {
      fixed: false,
      headerLinks: [],
    };
  },
  computed: {
    ...mapGetters(`auth`, [
      `isAuthenticated`,
    ]),
    wpUrl() {
      return config.wp;
    },
    page() {
      return this.$store.state.app.page;
    },
    loading() {
      return this.$store.state.app.state.loading;
    },
  },

  // Lifecycle
  mounted() {
    createScroll(`header`, {
      el: this.$el,
      move: e => {
        if (e.scrollY > 0 && this.fixed === false) this.fixed = true;
        else if (e.scrollY <= 0 && this.fixed === true) this.fixed = false;
      },
    });
  },
  destroyed() {
    destroyScroll(`header`);
  },
};
</script>



// WEBPACK FOOTER //
// Header.vue?6f86a0f2